import React from 'react'
import styled from 'styled-components'

interface IComboBox {
  children: any
  className?: string
  onChange: (val: any) => void
  value: string | number
}

const SelectBox = styled.select`
  position: relative;
  width: 100%;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0.5rem 0;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.text1};
  font-size: 1.2rem;
  font-family: inherit;

  &::selection {
    font-family: inherit;
  }

  option {
    background-color: ${({ theme }) => theme.bg1};
    font-family: inherit;
  }
`

export default function ComboBox(props: IComboBox) {
  const { className, value, onChange } = props
  return (
    <SelectBox className={className} value={value} onChange={e => onChange(e.target.value)}>
      {props.children}
    </SelectBox>
  )
}
